import { DateTime } from "luxon"
import { makeStyles } from "tss-react/mui"
import { Box, IconButton } from "@mui/material"
import { faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../../../../../../modules/localization/components/AppLocalized"
import { FormikTimePicker } from "../../../../../../forms/Formik"
import { MinMaxTimeLimitsProps } from "./useDeliveryTimeLimits"

const useStyles = makeStyles()((theme) => ({
    deliveryTimeRow: {
        display: "grid",
        alignItems: "flex-start",
        gridTemplateColumns: "1fr 1.5rem",
        gap: "1rem",
    },
    removeTimeButton: {
        padding: 0,
        marginTop: ".625rem",
        color: theme.palette.tailwind.slate[400],
    },
}))

type PopoverDeliveryTimeFormContentProps = Readonly<{
    index: number
    total: number
    onRemove: () => void
    shouldDisableTime: (value: DateTime, view: "hours" | "minutes" | "seconds") => boolean
    shouldForceOpen: boolean
    minMaxTime: MinMaxTimeLimitsProps
}>

export function DeliveryTimeRow({
    index,
    total,
    onRemove,
    shouldDisableTime,
    shouldForceOpen,
    minMaxTime,
}: PopoverDeliveryTimeFormContentProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.deliveryTimeRow}>
            <LocalizedStrict
                id="create-order-delivery-times-dialog-delivery-field"
                attrs={{ label: true }}
                vars={{ count: index + 1 }}
            >
                <FormikTimePicker
                    name={`deliveryTimes.${index}.time`}
                    label="Delivery"
                    shouldDisableTime={shouldDisableTime}
                    forceOpen={shouldForceOpen}
                    showMobilePicker={false}
                    minTime={minMaxTime?.minTime ?? undefined}
                    maxTime={minMaxTime?.maxTime ?? undefined}
                />
            </LocalizedStrict>

            {total > 1 && (
                <IconButton onClick={onRemove} className={classes.removeTimeButton}>
                    <FontAwesomeIcon icon={faTrashCan} size="xs" />
                </IconButton>
            )}
        </Box>
    )
}
